import { FetchCommunitiesCountDataProvider } from 'components/CustomFieldModal/Contexts/FetchCommunitiesCount.data.context';
import { QuerySwitch } from 'components/QuerySwitch';
import { CustomFieldsSettingsComponentPropsProvider } from 'pages/SettingsPage/CustomFieldsSettingsPage/contexts/CustomFieldsSettingsComponent.props.context';
import {
  FetchCustomFieldsDataContext,
  FetchCustomFieldsDataProvider,
} from 'pages/SettingsPage/CustomFieldsSettingsPage/contexts/FetchCustomFields.data.context';
import { CustomFieldsSettingsComponent } from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettingsComponent';

export default function CustomFieldsPage() {
  return (
    <FetchCustomFieldsDataProvider>
      <FetchCommunitiesCountDataProvider>
        <QuerySwitch
          context={FetchCustomFieldsDataContext}
          component={() => (
            <CustomFieldsSettingsComponentPropsProvider>
              <CustomFieldsSettingsComponent />
            </CustomFieldsSettingsComponentPropsProvider>
          )}
        />
      </FetchCommunitiesCountDataProvider>
    </FetchCustomFieldsDataProvider>
  );
}
